import React from "react";
import PropTypes from "prop-types";
import { FilterSelect } from "@td/ui";
import { useStates } from "../contexts/states-context";

const StateFilter = React.memo(({ value, label, placeholder, onChange }) => {
  const options = useStates();

  return (
    <FilterSelect
      isMulti
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={options}
    />
  );
});

StateFilter.propTypes = {
  value:       PropTypes.array.isRequired,
  onChange:    PropTypes.func.isRequired,
  label:       PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

StateFilter.displayName = "StateFilter";

export default StateFilter;
